import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "form-dialog__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "开票内容")
], -1)
const _hoisted_2 = { class: "form-dialog__content" }

import {
  withDefaults,
  ref,
  computed,
  defineModel
} from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseDatePicker,
  BaseSelect
} from 'xrk-components';
import {
  MakeOutAnInvoiceParams,
  NotInvoicedListParams
} from '@V/invoice/src/data-source/types';
import { ORDER_TYPE, PAY_TYPE } from '@constants/order';
import {
  obtainTheSeller,
  invoiceCategory
} from '@V/invoice/src/data-source/apis';
import { taxPatternMapping } from '@constants/project';
import { PAY_PASSAGEWAY_MAPPING } from '@constants/bank';
import appStore from '@/store';
import { storeToRefs } from 'pinia';
import { INVOICE_TYPE } from '@V/invoice/src/constants';
import { OrderType } from '@/common/types/order';

// 定义表单数据类型，合并开票参数和未开票列表参数
type FormData = MakeOutAnInvoiceParams & NotInvoicedListParams;

// 组件属性定义

export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-open-dialog-content',
  props: /*#__PURE__*/_mergeModels({
    disabled: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {



// 获取用户信息
const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);

// 表单数据模型绑定
// 注意：其中stateType使用销售方中返回数据，与订单类型无联动关系。
// 如果出现两个相同企业且其中stateType不一致，则会出现2条数据并且导致选择器异常：销售方唯一标识ID重复
const formData = _useModel<FormData>(__props, "modelValue");

// 表单引用
const formRef = ref(null);

// 订单类型状态（独立于formData中的stateType）
// 与formData中的stateType可能不一样，也无联动关系。仅提供给销售方接口入参、交易结构required校验
const stateType = ref<MakeOutAnInvoiceParams['stateType']>(null);

// 表单验证规则
const formRules = computed(() => {
  return {
    // stateType: [{ required: true, message: '请选择', trigger: 'change' }],
    theSellerId: [{ required: true, message: '请选择', trigger: 'change' }],
    itemId: [{ required: true, message: '请选择', trigger: 'change' }],
    taxPattern: [
      {
        required: stateType.value === 1, // stateType为1（项目类型订单）必填，其他非必填
        message: '请选择',
        trigger: 'change'
      }
    ],
    invoiceType: [{ required: true, message: '请选择', trigger: 'change' }]
  };
});

// 根据用户功能码计算可选的订单类型
const orderType = computed(() => {
  // 功能码为2时，只显示特定订单类型（1, 4, 5）
  if (userInfo.value.functionCode === 2) {
    return Object.values(ORDER_TYPE).filter(item =>
      [1, 4, 5].includes(item.value)
    );
  }
  // 功能码为3时（供应商），只显示综合服务费选项（6）
  if (userInfo.value.functionCode === 3) {
    return Object.values(ORDER_TYPE).filter(item => [6].includes(item.value));
  }
  // 默认显示所有订单类型
  return ORDER_TYPE;
});

// 获取销售方远程数据方法
const stateTypeRemote = () => {
  return obtainTheSeller({
    userDefinedOrderType: ([1, 2, 3, 7].includes(stateType.value)
      ? 1
      : stateType.value) as OrderType
  });
};

// 获取开票类目远程数据方法
const itemIdRemote = () => {
  return invoiceCategory({
    stateType: formData.value.stateType || stateType.value, // 优先使用选择的销售方中携带的类型数据
    invoiceType: formData.value.invoiceType,
    theSellerId: formData.value.theSellerId
  });
};

// 订单类型变更处理
const onStateTypeChange = v => {
  // 同步设置用户自定义订单类型
  formData.value.userDefinedOrderType = v;
  // 清空销售方选择
  formData.value.theSellerId = null;
  // 触发发票类型变更处理
  onInvoiceTypeChange();
};

// 销售方变更处理
const onTheSellerIdChange = (v, [option]) => {
  // 设置状态类型为选中销售方的状态类型
  formData.value.stateType = option.stateType;
  // 触发发票类型变更处理
  onInvoiceTypeChange();

  // 个体销售方项目时，交易结构写死个体产品5。运营提的
  formData.value.taxPattern = option.stateType === 7 ? 5 : null;
};

// 发票类型变更处理
const onInvoiceTypeChange = () => {
  // 清空开票类目选择
  formData.value.itemId = null;
};

// 暴露验证方法给父组件调用
__expose({
  validate: (...args: any) => formRef.value?.validate(...args)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    ref_key: "formRef",
    ref: formRef,
    "label-position": "top",
    scrollToError: "",
    model: formData.value,
    rules: formRules.value
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BaseFormItem), {
          label: "订单类型",
          prop: "stateType",
          rules: [
          {
            required: true,
            message: '请选择',
            trigger: 'change',
            validator: (rule, v, callback) => {
              // 验证订单类型是否已选择
              if (!stateType.value) {
                callback(new Error('请选择'));
              } else {
                callback();
              }
            }
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseSelect), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              modelValue: stateType.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((stateType).value = $event)),
              options: orderType.value,
              disabled: _ctx.disabled,
              onChange: onStateTypeChange
            }, null, 8, ["modelValue", "options", "disabled"])
          ]),
          _: 1
        }, 8, ["rules"]),
        _createVNode(_unref(BaseFormItem), {
          label: "销售方",
          prop: "theSellerId"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseSelect), {
              class: "form-dialog__w280",
              placeholder: "请选择",
              "label-key": "userDefinedName",
              "value-key": "userDefinedId",
              disabled: !stateType.value || _ctx.disabled,
              init: false,
              remoteMethod: stateTypeRemote,
              modelValue: formData.value.theSellerId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.theSellerId) = $event)),
              onChange: onTheSellerIdChange
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "发票类型",
          prop: "invoiceType"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseSelect), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              modelValue: formData.value.invoiceType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.invoiceType) = $event)),
              options: _unref(INVOICE_TYPE),
              disabled: _ctx.disabled,
              onChange: onInvoiceTypeChange
            }, null, 8, ["modelValue", "options", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "开票类目",
          prop: "itemId"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseSelect), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请选择",
              "label-key": "itemName",
              "value-key": "id",
              disabled: !formData.value.theSellerId || !formData.value.invoiceType || _ctx.disabled,
              init: false,
              remoteMethod: itemIdRemote,
              modelValue: formData.value.itemId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.itemId) = $event))
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "交易结构",
          prop: "taxPattern"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseSelect), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请选择",
              modelValue: formData.value.taxPattern,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.taxPattern) = $event)),
              options: _unref(taxPatternMapping),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "options", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "支付通道",
          prop: "payPassagewayCode"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseSelect), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请选择",
              modelValue: formData.value.payPassagewayCode,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.payPassagewayCode) = $event)),
              options: _unref(PAY_PASSAGEWAY_MAPPING),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "options", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "选择日期",
          prop: "receiveAt"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseDatePicker), {
              class: "form-dialog__w280",
              style: {"width":"280px"},
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              type: "daterange",
              modelValue: formData.value.receiveAt,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.receiveAt) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "付款方式",
          prop: "payType"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseSelect), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请选择",
              modelValue: formData.value.payType,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.payType) = $event)),
              options: _unref(PAY_TYPE),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "options", "disabled"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}
}

})